import messages from '@/locales/messages.json'

export default defineNuxtPlugin(() => {
    const localeCookie = useCookie('LOCALE')

    const getI18n = (i18nObject: object) => {
        if (!i18nObject) {
            return ''
        }
        const lang = localeCookie.value ? localeCookie.value : 'nb'

        if (i18nObject[lang] && i18nObject[lang] !== '') {
            return i18nObject[lang]
        }

        for (let locale in i18nObject) {
            if (i18nObject[locale] !== '') {
                return i18nObject[locale]
            }
        }

        return ''
    }

    return {
        provide: {
            messages,
            getI18n
        }
    }
})
